// Base Login Provider Class which implements LoginProvider Interface
// * loadscript is a function that load facebook sdk into DOM head
export class BaseLoginProvider {
    loadScript(id, src, onload, async = true) {
        if (document.getElementById(id)) {
            return;
        }
        const signInJS = document.createElement('script');
        signInJS.async = async;
        signInJS.src = src;
        signInJS.onload = onload;
        signInJS.id = id;
        document.head.appendChild(signInJS);
    }
}
